import { isProd } from './config';

export const AUTH0_DOMAIN = isProd ? 'login.teamengine.io' : 'teamengine-dev.us.auth0.com';
export const AUTH0_CLIENT_ID = isProd
  ? 'VIPb32nNZyHPfJ2PMsEBSlE2TtqKi6J6'
  : 'BK6WwUPICRO8WlbmYORBTfWJT6e93Fdx';

// The Auth0 audience is the unique identifier for the API (not an actually used endpoint)
// See our configuration at: https://manage.auth0.com/dashboard/us/teamengine/apis/5fd2389a732a01003fd6f635/settings
export const AUTH0_AUDIENCE = isProd
  ? 'https://api.expeditiondata.com'
  : 'https://local.employer.expeditiondata.com:8043';
